"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get bool () {
        return bool;
    },
    get d20 () {
        return d20;
    },
    get date () {
        return date;
    },
    get daysFromNow () {
        return daysFromNow;
    },
    get floating () {
        return floating;
    },
    get hoursFromNow () {
        return hoursFromNow;
    },
    get integer () {
        return integer;
    },
    get isEyes () {
        return isEyes;
    },
    get minutesFromNow () {
        return minutesFromNow;
    },
    get n () {
        return n;
    },
    get natural () {
        return natural;
    },
    get paragraph () {
        return paragraph;
    },
    get pickone () {
        return pickone;
    },
    get pickset () {
        return pickset;
    },
    get secondsFromNow () {
        return secondsFromNow;
    },
    get sentence () {
        return sentence;
    },
    get shuffle () {
        return shuffle;
    },
    get url () {
        return url;
    },
    get word () {
        return word;
    }
});
const _chance = require("chance");
const chance = new _chance.Chance();
function isEyes() {
    return typeof window !== 'undefined' && window.location.search.includes('eyes-storybook=true');
}
function pickset(arr, size) {
    if (isEyes()) {
        return arr.slice(0, size);
    }
    return chance.pickset(arr, size);
}
function pickone(arr, anotherOne) {
    if (isEyes()) {
        return arr[anotherOne ? 1 : 0];
    }
    return chance.pickone(arr);
}
function natural(config) {
    if (isEyes()) {
        var _config_max;
        return (_config_max = config === null || config === void 0 ? void 0 : config.max) !== null && _config_max !== void 0 ? _config_max : 0;
    }
    return chance.natural(config);
}
function integer(config) {
    if (isEyes()) {
        return 3124353;
    }
    return chance.integer(config);
}
function floating(config) {
    if (isEyes()) {
        return 432.35;
    }
    return chance.floating(config);
}
function word(opts) {
    if (isEyes()) {
        return 'potato';
    }
    return chance.word(opts);
}
function sentence(config) {
    if (isEyes()) {
        return (config === null || config === void 0 ? void 0 : config.words) ? 'Mudkips '.repeat(config.words) : 'Mudkips';
    }
    return chance.sentence(config);
}
function paragraph(opts) {
    if (isEyes()) {
        return 'Lorem ipsum dolor sit amet';
    }
    return chance.paragraph(opts);
}
function url(opts) {
    if (isEyes()) {
        return 'http://www.deviantart.com/';
    }
    return chance.url(opts);
}
function bool(opts) {
    if (isEyes()) {
        return false;
    }
    return chance.bool(opts);
}
function date(opts) {
    if (isEyes()) {
        return new Date('2019-03-08');
    }
    return chance.date(opts);
}
function d20() {
    if (isEyes()) {
        return 14;
    }
    return chance.d20();
}
function shuffle(arr) {
    if (isEyes()) {
        return arr.reduceRight((acc, value)=>{
            acc.push(value);
            return acc;
        }, []);
    }
    return chance.shuffle(arr);
}
function n(generator, count) {
    return chance.n(generator, count);
}
function secondsFromNow(seconds) {
    const now = new Date();
    now.setSeconds(now.getSeconds() + seconds);
    return now;
}
function minutesFromNow(minutes) {
    const now = new Date();
    now.setMinutes(now.getMinutes() + minutes);
    return now;
}
function hoursFromNow(hours) {
    const now = new Date();
    now.setHours(now.getHours() + hours);
    return now;
}
function daysFromNow(days) {
    const now = new Date();
    now.setDate(now.getDate() + days);
    return now;
}
